module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xheads1-51c880f8f8592ce1bcd01ad735c747fd.jpg";